import { ExternalLink } from 'lucide-react';
import React from 'react';

import { SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@column/ui';

import { DocsIcon, HelpIcon } from '~/elements/icons';
import { useHelpSidebarStore } from '~/stores/HelpSidebar';
import { useSessionStore } from '~/stores/Session';
import { log } from '~/util';

export const NavSecondary: React.FC = () => {
  const { openHelpSidebar } = useHelpSidebarStore();
  const currentUser = useSessionStore((s) => s.currentUser);

  const handleDocsClick = () => {
    log({
      name: 'Documentation clicked',
      context: currentUser,
    });
    window.open('https://docs.column.com');
  };

  return (
    <SidebarGroup className="pb-2">
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className="group/docs">
              <button type="button" onClick={handleDocsClick}>
                <DocsIcon />
                <span>Documentation</span>
                <ExternalLink className="ml-auto size-3.5 text-gray-400 opacity-0 transition-opacity duration-150 group-hover/docs:opacity-100" />
              </button>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild>
              <button type="button" onClick={() => openHelpSidebar('Support')}>
                <HelpIcon />
                <span>Help</span>
              </button>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
